module.exports = __webpack_public_path__ + "static/media/hamsa.167c3a55.svg";